<template>
    <div v-if="componentData" class="small-wrapper TwoColumnsFacts">
        <h2>
            {{componentData.twoColumnsFactsTitle}}
        </h2>
        <div class="grid two">
            <div class="facts__block" v-for="(block,index) in componentData.blocks">
                <div class="index__holder">
                    0{{index+1}}
                </div>
                <div class="facts__block__title">
                    {{block.Number}}
                </div>
                <p>{{block.Description}}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
